module.exports = __webpack_public_path__ + "1f0fc162a5536c09d5ac7ce0ddc5eb74.png";